if (!customElements.get('event-gallery')) {
  customElements.define('event-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.setupCarousel(options);
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('[data-viewer-image]');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-open-event]');
        if (opener && !opener.disabled) this.openEvent(opener);
        if (event.target.closest('[data-close]') || event.target === this.dialog || event.target.classList.contains('event-gallery__stage')) this.dialog.close();
        if (event.target.closest('[data-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-next]')) this.show(this.index + 1);
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.image.removeAttribute('src');
        this.opener?.focus({ preventScroll: true });
      }, options);
      const stage = this.querySelector('.event-gallery__stage');
      stage.addEventListener('touchstart', event => {
        this.touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }, { ...options, passive: true });
      stage.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        this.touchStart = null;
      }, { ...options, passive: true });
      document.addEventListener('shopify:block:select', event => {
        if (this.dialog.open) this.dialog.close();
        const block = [...this.querySelectorAll('[data-event]')].find(el => el.dataset.blockId === event.detail.blockId);
        block?.scrollIntoView({ block: 'nearest' });
      }, options);
    }
    setupCarousel(options) {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;
      const cards = [...this.track.querySelectorAll('[data-event]')];
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const progress = this.querySelector('[data-gallery-progress]');
      const sync = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const left = Math.max(0, this.track.scrollLeft);
        previous.disabled = left < 2;
        next.disabled = left >= max - 2;
        this.querySelector('[data-gallery-navigation]').hidden = max < 2;
        const portion = this.track.clientWidth / this.track.scrollWidth;
        progress.style.width = `${Math.min(1, portion + (max ? left / max : 0) * (1 - portion)) * 100}%`;
      };
      const move = direction => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const origin = this.track.getBoundingClientRect().left;
        const stops = cards.map(card => Math.min(max, card.getBoundingClientRect().left - origin + this.track.scrollLeft));
        const left = direction > 0 ? stops.find(stop => stop > this.track.scrollLeft + 2) ?? max : stops.reverse().find(stop => stop < this.track.scrollLeft - 2) ?? 0;
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'instant' });
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', sync, { ...options, passive: true });
      this.resize?.disconnect();
      this.resize = new ResizeObserver(sync);
      this.resize.observe(this.track);
      sync();
    }
    openEvent(opener) {
      const event = opener.closest('[data-event]');
      this.photos = [...event.querySelectorAll('[data-photo]')];
      if (!this.photos.length) return;
      this.opener = opener;
      this.querySelector('[data-viewer-title]').textContent = event.querySelector('[data-event-title]').textContent;
      this.eventDescription = event.querySelector('.event-gallery__description')?.textContent || '';
      this.show(0);
      this.dialog.showModal();
      this.dialog.querySelector('[data-close]').focus();
    }
    show(index) {
      if (!this.photos?.length) return;
      this.index = (index + this.photos.length) % this.photos.length;
      this.image.src = this.photos[this.index].dataset.src;
      this.image.alt = this.photos[this.index].dataset.alt;
      this.querySelector('[data-position]').textContent = `${this.index + 1} / ${this.photos.length}`;
      this.dialog.querySelectorAll('[data-prev], [data-next]').forEach(button => { button.hidden = this.photos.length < 2; });
      const caption = this.querySelector('[data-viewer-caption]');
      caption.textContent = this.photos[this.index].dataset.caption || this.eventDescription;
      caption.hidden = !caption.textContent;
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
